var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-container",on:{"click":function($event){return _vm.setHmt('顶部导航_点击【消息通知】')}}},[_c('div',{attrs:{"id":"component147852"}})])}
var staticRenderFns = []

export { render, staticRenderFns }